import { createBrowserRouter } from "react-router-dom";

import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import Customers from "./Pages/Customers/Customers";
import Auth from "./Pages/Auth/Auth";

import YukxatiGlobal from "./Pages/YukXati/YukxatiGlobal";

import WievYukXati from "./Pages/YukXati/ViewYukXati/ViewYukXati";
import CustomerView from "./Pages/Customers/CustomerView";
import YukXatiAdd from "./Pages/YukXati/YukXatiAdd/YukXatiAdd";
import YukXatiKirim from "./Pages/YukXati/Kirim/YukXatiKirim";
import AddYukXatiKirim from "./Pages/YukXati/Kirim/AddYukXatiKirim";
import NetworkSpeedAlert from "./Components/NetworkSpeedAlert/NetworkSpeedAlert";
import Tickets from "./Pages/Tickets/Tickets";
import Imzo from "./Pages/Customers/Imzo";
import CustomerEdit from "./Pages/Customers/CustomerEdit";
import Products from "./Pages/Products/Products";
import Kocha from "./Pages/kocha/Kocha";
import Vagon from "./Pages/kocha/vagon/Vagon";
import KochaView from "./Pages/kocha/KochaView";
import AddVagon from "./Pages/kocha/vagon/AddVagon";
import VagonView from "./Pages/kocha/vagon/VagonView";
import TicketsKirim from "./Pages/Tickets/Kirim/TicketsKirim";
import EditVagon from "./Pages/kocha/vagon/EditVagon";
import Calculation from "./Pages/Tickets/Calculation/Calculation";
import Kassa from "./Pages/Kassa/Kassa";
import ArchiveView from "./Pages/Customers/CustomerViews/Archive/ArchiveView";

const router = createBrowserRouter([
  {
    path: "/auth",
    element: (
      <NetworkSpeedAlert>
        {" "}
        <Auth />{" "}
      </NetworkSpeedAlert>
    ),
  },
  {
    path: "/kocha/vagonlar",
    element: (
      <NetworkSpeedAlert>
        {" "}
        <Vagon />{" "}
      </NetworkSpeedAlert>
    ),
  },
  {
    path: "/kassa",
    element: (
      <NetworkSpeedAlert>
        <Kassa />
      </NetworkSpeedAlert>
    ),
  },
  {
    path: "/kocha/vagon/:id",
    element: (
      <NetworkSpeedAlert>
        {" "}
        <VagonView />{" "}
      </NetworkSpeedAlert>
    ),
  },
  {
    path: "/kocha/vagonlar/new",
    element: (
      <NetworkSpeedAlert>
        {" "}
        <AddVagon />{" "}
      </NetworkSpeedAlert>
    ),
  },
  {
    path: "/kocha/vagonlar/edit/:id",
    element: (
      <NetworkSpeedAlert>
        {" "}
        <EditVagon />{" "}
      </NetworkSpeedAlert>
    ),
  },
  {
    path: "/kocha/:id",
    element: (
      <NetworkSpeedAlert>
        {" "}
        <KochaView />{" "}
      </NetworkSpeedAlert>
    ),
  },
  {
    path: "/kocha",
    element: (
      <NetworkSpeedAlert>
        {" "}
        <Kocha />{" "}
      </NetworkSpeedAlert>
    ),
  },
  {
    path: "/products",
    element: (
      <NetworkSpeedAlert>
        {" "}
        <Products />{" "}
      </NetworkSpeedAlert>
    ),
  },
  {
    path: "/yukxati",
    element: (
      <NetworkSpeedAlert>
        <YukxatiGlobal />{" "}
      </NetworkSpeedAlert>
    ),
  },

  {
    path: "/yukxati/kirim",
    element: (
      <NetworkSpeedAlert>
        {" "}
        <YukXatiKirim />
      </NetworkSpeedAlert>
    ),
  },
  {
    path: "/yukxati/kirim/new",
    element: (
      <NetworkSpeedAlert>
        <AddYukXatiKirim />
      </NetworkSpeedAlert>
    ),
  },
  {
    path: "/yukxati/:id",
    element: (
      <NetworkSpeedAlert>
        {" "}
        <WievYukXati />{" "}
      </NetworkSpeedAlert>
    ),
  },
  {
    path: "/yukxati/new/:id",
    element: (
      <NetworkSpeedAlert>
        {" "}
        <YukXatiAdd />{" "}
      </NetworkSpeedAlert>
    ),
  },

  {
    path: "/customers/",
    element: (
      <NetworkSpeedAlert>
        {" "}
        <Customers />{" "}
      </NetworkSpeedAlert>
    ),
    children: [
      // Define child routes here
      {
        index: true, // This is the default route when path is "/"
        element: (
          <NetworkSpeedAlert>
            {/* <div className="w-[100%] h-100%] flex flex-row items-center justify-center pt-[200px]">
              <h2 className="bold text-[25px]">Klient tanlang : )</h2>
            </div> */}
            <main class="grid  place-items-center bg-white  w-[100%] h-100%] flex flex-row items-center justify-center pt-[200px]">
              <div class="text-center">
                <p class="mt-6 text-lg font-medium text-pretty text-gray-500 sm:text-xl/8 bold">
                  Klient tanlang : )
                </p>
              </div>
            </main>
          </NetworkSpeedAlert>
        ),
      },
      {
        path: ":id",
        element: (
          <NetworkSpeedAlert>
            {" "}
            <CustomerView />{" "}
          </NetworkSpeedAlert>
        ),
      },
    ],
  },
  {
    path: "/customer/arkhiv/:id",
    element: (
      <NetworkSpeedAlert>
        {" "}
        <ArchiveView />
      </NetworkSpeedAlert>
    ),
  },

  {
    path: "/customer/:id",
    element: (
      <NetworkSpeedAlert>
        {" "}
        <CustomerView />
      </NetworkSpeedAlert>
    ),
  },
  {
    path: "/customer/imzo/:id",
    element: (
      <NetworkSpeedAlert>
        {" "}
        <Imzo />{" "}
      </NetworkSpeedAlert>
    ),
  },

  {
    path: "/customers/edit/:id",
    element: (
      <NetworkSpeedAlert>
        {" "}
        <CustomerEdit />{" "}
      </NetworkSpeedAlert>
    ),
  },

  {
    path: "/tickets",
    element: (
      <NetworkSpeedAlert>
        <Tickets />{" "}
      </NetworkSpeedAlert>
    ),
  },
  {
    path: "/calculation",
    element: (
      <NetworkSpeedAlert>
        <Calculation />{" "}
      </NetworkSpeedAlert>
    ),
  },
  {
    path: "/tickets/kirim",
    element: (
      <NetworkSpeedAlert>
        <TicketsKirim />{" "}
      </NetworkSpeedAlert>
    ),
  },

  {
    path: "/",
    element: (
      <NetworkSpeedAlert>
        <App />{" "}
      </NetworkSpeedAlert>
    ),
  },
]);

export default router;
